<template>
  <content-with-sidebar sidebar-width="312px" sidebar-offset="332px">
    <template slot="sidebar">
      <div>
        <box class="pb-6 d-none d-lg-block">
          <h3 class="txt-3-alt mb-4">Payment methods:</h3>
          <b-form-group class="switcher-group">
            <b-form-radio-group
              v-model="selectedView"
              :options="paymentMethods"
              name="adZoneTypes"
              class="has-custom-radio-lg"
              stacked
            />
          </b-form-group>
          <h3 class="txt-3-alt mb-4">History:</h3>
          <b-form-group class="switcher-group mb-0">
            <b-form-radio-group
              v-model="selectedView"
              :options="historyOptions"
              name="adZoneTypes"
              class="has-custom-radio-lg"
              stacked
            />
          </b-form-group>
        </box>
        <div class="d-block d-lg-none">
          <multi-select
            :options="{ multi: false }"
            :select-options="mobileSwitcher"
            size="lg"
            v-model="switcherValue"
          />
        </div>
      </div>
    </template>
    <template slot="content">
      <box>
        <b-row>
          <b-col cols="12" md="6" lg="4" v-if="selectedView === 'paypal'">
            <template v-if="user.isApproovedForPaypalAutorecharge">
              <h4>PayPal Auto-Recharge</h4>
              <label for="auto-recharge" class="col-form-label">
                Auto-rechare amount:
              </label>
              <b-input-group prepend="$">
                <b-form-input
                  id="auto-recharge"
                  :disabled="user.paypalAutorechargeEnabled.active"
                  v-model="user.paypalAutorechargeEnabled.amount"
                  type="text"
                />
              </b-input-group>
              <strong class="small text-warning">
                * Your account will be recharged (max. 3 times per day) when it
                falls below $20
              </strong>
              <div>
                <b-button
                  variant="primary"
                  class="mt-2"
                  @click.stop="paypalAutorechargeUpdate()"
                >
                  <template v-if="user.paypalAutorechargeEnabled.active">
                    Disable
                  </template>
                  <template v-else>
                    Enable
                  </template>
                </b-button>
              </div>
              <hr />
              <h4>PayPal Manual Recharge</h4>
              <label for="auto-recharge" class="col-form-label">
                Amount:
              </label>
              <b-input-group prepend="$">
                <b-form-input
                  id="auto-recharge"
                  v-model="paypalManual.amount"
                  type="text"
                />
              </b-input-group>
              <b-button
                variant="primary"
                class="mt-4"
                @click.stop="paypalCharge()"
              >
                Checkout with paypal
              </b-button>
            </template>
          </b-col>
          <b-col cols="12" md="6" lg="4" v-if="selectedView === 'paxum'">
            <label for="auto-recharge" class="col-form-label"> Amount: </label>
            <b-input-group prepend="$">
              <b-form-input
                id="auto-recharge"
                v-model="paxum.amount"
                type="text"
              />
            </b-input-group>
            <b-button
              variant="primary"
              class="mt-4"
              @click.stop="paypalCharge()"
            >
              Checkout with paxum
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" v-if="selectedView === 'webmoney'">
            <label for="auto-recharge" class="col-form-label"> Amount: </label>
            <b-input-group prepend="$">
              <b-form-input
                id="auto-recharge"
                v-model="webmoney.amount"
                type="text"
              />
            </b-input-group>
            <b-button
              variant="primary"
              class="mt-4"
              @click.stop="paypalCharge()"
            >
              Checkout with webmoney
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="7" xl="4" v-if="selectedView === 'wire'">
            <h4>Details:</h4>
            <span class="small text-warning">
              <strong>
                * You may send payments directly by wire transfer. Minimum
                payment is strong.
              </strong>
            </span>
            <b-tabs no-nav-style nav-class="custom-tabs" v-model="tabIndex">
              <b-tab title="USD" active>
                <div class="details py-3 px-2">
                  <div class="py-1">
                    <strong>Bank name:</strong>
                    <pre
                      id="bank-name"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Banco Santander S.A.
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Account name:</strong>
                    <pre
                      id="acc-name"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      EXOCLICK S.L.
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Bank address:</strong>
                    <pre
                      id="bank-address"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Marina 16-18, 18B, 08005 Barcelona
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Country:</strong>
                    <pre
                      id="country"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Spain
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>SWIFT:</strong>
                    <pre
                      id="swift-code"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      BSCHESMMXXX
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Account number for USD transfers:</strong>
                    <pre
                      id="acc-number-usd"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      0049-5520-29-2010124171
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>IBAN for USD transfers:</strong>
                    <pre
                      id="iban-usd"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      ES7700495520292010124171
                    </pre>
                  </div>
                </div>
              </b-tab>
              <b-tab title="EUR">
                <div class="details py-3 px-2">
                  <div class="py-1">
                    <strong>Bank name:</strong>
                    <pre
                      id="bank-name"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Banco Santander S.A.
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Account name:</strong>
                    <pre
                      id="acc-name"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      EXOCLICK S.L.
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Bank address:</strong>
                    <pre
                      id="bank-address"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Marina 16-18, 18B, 08005 Barcelona
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Country:</strong>
                    <pre
                      id="country"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      Spain
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>SWIFT:</strong>
                    <pre
                      id="swift-code"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      BSCHESMMXXX
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>Account number for EUR transfers:</strong>
                    <pre
                      id="acc-number-uur"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      0049-5520-26-2310123060
                    </pre>
                  </div>
                  <div class="py-1">
                    <strong>IBAN for EUR transfers:</strong>
                    <pre
                      id="iban-eur"
                      class="d-inline"
                      v-clipboard:copy="'Banco Santander S.A.'"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError"
                    >
                      ES3100495520262310123060
                    </pre>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </b-col>
          <b-col
            class="wire-notify"
            cols="12"
            md="6"
            lg="5"
            xl="4"
            v-if="selectedView === 'wire'"
          >
            <h4>Notify us about your transfer:</h4>
            <label for="wire-sender-name" class="col-form-label pb-0">
              Wire sender name:
            </label>
            <b-input-group>
              <b-form-input
                id="wire-sender-name"
                v-model="wire.senderName"
                type="text"
              />
            </b-input-group>
            <label for="wire-amount" class="col-form-label pb-0">
              Amount:
            </label>
            <b-input-group>
              <b-input-group-prepend>
                <b-form-select
                  class="rounded-right-0"
                  v-model="wire.currency.name"
                  :options="[
                    { value: 'eur', text: 'EUR' },
                    { value: 'usd', text: 'USD' }
                  ]"
                />
              </b-input-group-prepend>
              <b-form-input
                id="wire-amount"
                v-model="wire.amount"
                type="text"
              />
            </b-input-group>
            <div class="text-right mt-4">
              <b-button variant="primary"> submit </b-button>
            </div>
          </b-col>
          <b-col v-if="selectedView === 'history'">
            <div class="table-responsive">
              <b-table
                v-if="paymentsHistory"
                class="mb-0"
                hover
                bordered
                :fields="fields"
                :items="paymentsHistory"
              >
                <template slot="invoice" slot-scope="item">
                  <router-link
                    :to="{ name: 'invoice', params: { id: item.id } }"
                  >
                    invoice
                  </router-link>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
      </box>
    </template>
  </content-with-sidebar>
</template>

<script>
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);
import ContentWithSidebar from '@/components/Layout/ContentWithSidebar.vue';

export default {
  components: {
    ContentWithSidebar
  },

  data() {
    return {
      tabIndex: 0,
      selectedView: 'paypal',
      switcherValue: [{ text: 'PayPal', value: 'paypal' }],
      paymentMethods: [
        { text: 'PayPal', value: 'paypal' },
        { text: 'Paxum', value: 'paxum' },
        { text: 'Web Money', value: 'webmoney' },
        { text: 'Wire transfer', value: 'wire' }
      ],
      historyOptions: [{ text: 'History', value: 'history' }],
      paypalManual: {
        amount: 0
      },
      paxum: {
        amount: 0
      },
      webmoney: {
        amount: 0
      },
      wire: {
        amount: 0,
        currency: {
          name: 'usd'
        },
        senderName: null
      },
      user: {
        isApproovedForPaypalAutorecharge: true,
        paypalAutorechargeEnabled: {
          amount: 200,
          active: true
        }
      },
      paymentsHistory: [],
      fields: [
        {
          key: 'type',
          label: 'Type',
          sortable: true
        },
        {
          key: 'invoiceDate',
          label: 'Invoice date',
          formatter: date => this.$date.format(date, 'DD.MM.YYYY'),
          sortable: true
        },
        {
          key: 'dateFunded',
          label: 'Date Funded',
          formatter: date => this.$date.format(date, 'DD.MM.YYYY'),
          sortable: true
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: true
        },
        {
          key: 'balanceAmount',
          label: 'Balance Amount',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'invoice',
          label: 'invoice'
        }
      ]
    };
  },

  computed: {
    mobileSwitcher() {
      return [...this.paymentMethods, ...this.historyOptions].map(el => {
        el.name = el.text;
        return el;
      });
    }
  },

  methods: {
    paypalAutorechargeUpdate() {
      if (this.user.paypalAutorechargeEnabled.active) {
        alert('auto recharge disabled');
        this.user.paypalAutorechargeEnabled.active = false;
        this.user.paypalAutorechargeEnabled.amount = 0;
      } else {
        alert('auto recharge enabled');
        this.user.paypalAutorechargeEnabled.active = true;
      }
    },
    paypalCharge() {
      alert('Money will be display in your profile after about few minutes');
    },
    onCopy: function(e) {
      alert('You just copied: ' + e.text);
    },
    onError: function() {
      alert('Failed to copy texts');
    },
    fetchPayments() {
      this.$api.adnet.get('/v0/deposits').then(res => {
        this.paymentsHistory = res;
      });
    }
  },

  watch: {
    selectedView(val) {
      if (val === 'history') {
        this.fetchPayments();
      }
    },
    switcherValue(val) {
      if (val.length) this.selectedView = val[0].value;
    },
    'wire.currency.name': function(val) {
      if (val === 'usd') this.tabIndex = 0;
      if (val === 'eur') this.tabIndex = 1;
    },
    tabIndex(val) {
      if (val === 0) this.wire.currency.name = 'usd';
      if (val === 1) this.wire.currency.name = 'eur';
    }
  }
};
</script>

<style lang="scss">
.wire-notify {
  .form-control:focus,
  .custom-select:focus {
    box-shadow: inset 0 0 0 1px $secondary, inset -1px 0 0 1px $secondary;
  }
}
</style>

<style lang="scss" scoped>
pre {
  white-space: normal;
  border: 1px solid $border-color;
  background: $light-bg;
  padding: 4px 7px;
}
</style>
